<div class="price-breakdown-steps"
  *ngIf="amendType === 'none' || (price.priceHistory && price.priceHistory.majorPriceDifference === 0)">

  <!-- Address Charge-->
  <div class="flex flex-always flex--align-start step"
    *ngIf="price.pricingResponse[0].pricingBreakdown.productLocationPriceMajor > 0">
    <i class="icon margin-right-24">location_pin</i>

    <div class="flex__item--grow">
      <div class="step__title fadeIn">
        {{ appCopy.panelHeader['addressCharges'+selectedLanguage] }}
      </div>

      <div class="step__details text-caption ">
        <p>{{ appCopy.panelHeader['additionalFee'+selectedLanguage] }}</p>
      </div>
    </div>

    <div class="step__price">
      {{price.totalPrice.currencySymbol}}{{price.totalPrice.currencySymbol==="CHF" ?
      ' ' : ''}}{{ price.pricingResponse[0].pricingBreakdown.productLocationPriceMajor }}
    </div>
  </div>

  <!-- bags  Charge-->
  <div class="flex flex-always flex--align-start step"
    *ngIf="price.pricingResponse[0].pricingBreakdown.productLocationPriceMajor > 0">
    <i class="icon margin-right-24">clock</i>

    <div class="flex__item--grow">
      <div class="flex-always flex--space-between">
        <p>{{ timeslot.date | date:'E, d MMM yyyy' :'' : languageCode }} {{ timeslot.start }} - {{ timeslot.end }}</p>
      </div>

      <div class="step__details text-caption ">
        <p *ngIf="bookingABC" class="text-caption">
          {{ appCopy.panelHeader['bagWithNoAdditionalCost'+selectedLanguage].replace('%s',
          price.pricingResponse[0].pricingBreakdown.productTierIncludedBags)
          .replace('%s', price.pricingResponse[0].pricingBreakdown.productTierIncludedBags === 1 ?
          appCopy.panelHeader['bagSelectText'+selectedLanguage] :
          appCopy.panelHeader['bagsSelectText'+selectedLanguage])
          }}
        </p>
        <p *ngIf="!bookingABC" class="text-caption">
          {{ appCopy.panelHeader['bagWithNoAdditionalCost'+selectedLanguage].replace('%s',
          price.pricingResponse[0].pricingBreakdown.productTierIncludedBags)
          .replace('%s', price.pricingResponse[0].pricingBreakdown.productTierIncludedBags === 1 ?
          appCopy.panelHeader['bagSelectText'+selectedLanguage] :
          appCopy.panelHeader['bagsSelectText'+selectedLanguage])
          }}
        </p>
      </div>
    </div>

    <div class="step__price">
      {{price.totalPrice.currencySymbol}}{{price.totalPrice.currencySymbol==="CHF" ?
      ' ' : ''}}{{ price.pricingResponse[0].pricingBreakdown.basePriceMajor }}
    </div>
  </div>


  <!-- Premium Surcharge -->

  <div class="flex flex-always flex--align-start step" *ngIf="premiumSurcharge.hasApplied">
    <i class="icon margin-right-24">card</i>

    <div class="flex__item--grow">
      <div class="step__title fadeIn">
        {{ appCopy.panelHeader['premiumSurcharge'+selectedLanguage] }}
      </div>

      <div class="step__details text-caption ">
        <p>{{ appCopy.panelHeader['premiumSurchargeCopy'+selectedLanguage] }}</p>
      </div>
    </div>

    <div class="step__price">
      {{price.totalPrice.currencySymbol}}{{price.totalPrice.currencySymbol==="CHF" ?
      ' ' : ''}}{{ premiumSurcharge.charge }}
    </div>
  </div>

  <!-- Peak Slot  -->

  <div class="flex flex-always flex--align-start step"
    *ngIf="price.pricingResponse[0].pricingBreakdown.slotAdjustedPriceMajor > 0">
    <i class="icon margin-right-24">clock</i>

    <div class="flex__item--grow">
      <div class="step__title fadeIn">
        {{ appCopy.panelHeader['peakSlot'+selectedLanguage] }}
      </div>

      <div class="step__details text-caption ">
        <p>{{ appCopy.panelHeader['additionalChargeForSlot'+selectedLanguage] }}</p>
      </div>
    </div>

    <div class="step__price">
      {{price.totalPrice.currencySymbol}}{{price.totalPrice.currencySymbol==="CHF" ?
      ' ' : ''}}{{ price.pricingResponse[0].pricingBreakdown.slotAdjustedPriceMajor }}
    </div>
  </div>

  <!-- bags  Charge-->
  <div class="flex flex-always flex--align-start step" *ngIf="price.pricingResponse[0].pricingBreakdown.sbbSubsidyMajor > 0">
    <i class="icon margin-right-24">clock</i>

    <div class="flex__item--grow">
      <div class="step__title fadeIn">
        {{ appCopy.panelHeader['publicTransportDiscountText'+selectedLanguage] }}
      </div>

      <div class="step__details text-caption ">
        <p *ngIf="bookingABC" class="text-caption">
          {{ appCopy.panelHeader['bagWithNoAdditionalCost'+selectedLanguage].replace('%s',
          price.pricingResponse[0].pricingBreakdown.productTierIncludedBags)
          .replace('%s', price.pricingResponse[0].pricingBreakdown.productTierIncludedBags === 1 ?
          appCopy.panelHeader['bagSelectText'+selectedLanguage] :
          appCopy.panelHeader['bagsSelectText'+selectedLanguage])
          }}
        </p>
        <p *ngIf="!bookingABC" class="text-caption">
          {{ appCopy.panelHeader['bagWithNoAdditionalCost'+selectedLanguage].replace('%s',
          price.pricingResponse[0].pricingBreakdown.productTierIncludedBags)
          .replace('%s', price.pricingResponse[0].pricingBreakdown.productTierIncludedBags === 1 ?
          appCopy.panelHeader['bagSelectText'+selectedLanguage] :
          appCopy.panelHeader['bagsSelectText'+selectedLanguage])
          }}
        </p>
      </div>
    </div>

    <div class="step__price">
      {{price.totalPrice.currencySymbol}}{{price.totalPrice.currencySymbol==="CHF" ?
      ' ' : ''}}
      {{ price.pricingResponse[0].pricingBreakdown.sbbSubsidyMajor }}
    </div>
  </div>

  <!-- Additional Bags -->


  <div class="flex flex-always flex--align-start step"
    *ngIf="price.pricingResponse[0].pricingBreakdown.additionalBagPriceMajor > 0">
    <i class="icon margin-right-24">luggage</i>

    <div class="flex__item--grow">
      <div class="step__title fadeIn">
        {{ appCopy.panelHeader['additionalBag'+selectedLanguage] }}
      </div>

      <div class="step__details text-caption ">
        <p> {{ price.pricingResponse[0].pricingBreakdown.numberOfBags -
          price.pricingResponse[0].pricingBreakdown.productTierIncludedBags >=
          price.pricingResponse[0].pricingBreakdown.bagVolumeLimit
          ? price.pricingResponse[0].pricingBreakdown.bagVolumeLimit -
          price.pricingResponse[0].pricingBreakdown.productTierIncludedBags
          : price.pricingResponse[0].pricingBreakdown.numberOfBags -
          price.pricingResponse[0].pricingBreakdown.productTierIncludedBags}}

          {{
          (price.pricingResponse[0].pricingBreakdown.numberOfBags -
          price.pricingResponse[0].pricingBreakdown.productTierIncludedBags) === 1 ?
          appCopy.panelHeader['bagSelectText'+selectedLanguage] :
          appCopy.panelHeader['bagsSelectText'+selectedLanguage] }}

          {{appCopy.panelHeader['at'+selectedLanguage]}}

          {{price.totalPrice.currencySymbol}}{{price.totalPrice.currencySymbol==="CHF" ? ' ' : ''}}{{
          price.pricingResponse[0].pricingBreakdown.pricePerBagMajor }} {{
          price.pricingResponse[0].pricingBreakdown.productTierIncludedBags === 1 ? '' :
          appCopy.panelHeader['each'+selectedLanguage] }}</p>
      </div>
    </div>

    <div class="step__price">
      {{price.totalPrice.currencySymbol}}{{price.totalPrice.currencySymbol==="CHF" ?
      ' ' : ''}}{{ price.pricingResponse[0].pricingBreakdown.additionalBagPriceMajor }}
    </div>
  </div>


  <!-- Bag volume Charge -->

  <div class="flex flex-always flex--align-start step"
    *ngIf="price.pricingResponse[0].pricingBreakdown.additionalBagVolumePriceMajor > 0">
    <i class="icon margin-right-24">luggage</i>

    <div class="flex__item--grow">
      <div class="step__title fadeIn">
        {{ appCopy.panelHeader['bagVolumCharge'+selectedLanguage] }}
      </div>
    </div>

    <div class="step__price">
      {{price.totalPrice.currencySymbol}}{{price.totalPrice.currencySymbol==="CHF" ?
      ' ' : ''}}{{ price.pricingResponse[0].pricingBreakdown.additionalBagVolumePriceMajor }}
    </div>
  </div>


  <!--Bag storage -->

  <div class="flex flex-always flex--align-start step"
    *ngIf="price.pricingResponse[0].pricingBreakdown.totalStoragePriceMajor > 0">
    <i class="icon margin-right-24">luggage</i>

    <div class="flex__item--grow">
      <div class="step__title fadeIn">
        {{ appCopy.panelHeader['bagStorage'+selectedLanguage] }}
      </div>

      <div class="step__details text-caption ">
        <p>{{price.totalPrice.currencySymbol}}{{price.totalPrice.currencySymbol==="CHF" ? ' ' :
          ''}}{{ price.pricingResponse[0].pricingBreakdown.storagePricePerNightPerBagMajor }} {{
          appCopy.panelHeader['chargePerBag'+selectedLanguage] }}</p>
      </div>
    </div>

    <div class="step__price">
      {{price.totalPrice.currencySymbol}}{{price.totalPrice.currencySymbol==="CHF" ? ' ' :
      ''}}{{ price.pricingResponse[0].pricingBreakdown.storagePricePerNightPerBagMajor }} {{
      appCopy.panelHeader['chargePerBag'+selectedLanguage] }}
    </div>
  </div>

  <!-- Total -->
</div>

<div *ngIf="amendType !== 'none' && price.priceHistory.majorPriceDifference !== 0">

  <p class="margin-bottom-8 clearfix" *ngIf="price.priceHistory.majorAmount !== 0">
    <span *ngIf="amendType === 'payment'"
      class="pull-right">{{price.totalPrice.currencySymbol}}{{price.totalPrice.currencySymbol==="CHF" ? ' ' : ''}}{{
      price.totalPrice.majorAmount - price.priceHistory.majorPriceDifference }}</span>
    <span *ngIf="amendType === 'refund'"
      class="pull-right">{{price.totalPrice.currencySymbol}}{{price.totalPrice.currencySymbol==="CHF" ? ' ' : ''}}{{
      price.totalPrice.majorAmount + (price.priceHistory.majorPriceDifference * -1) }}</span>
    <strong>{{ appCopy.panelHeader['orignalPrice'+selectedLanguage] }}</strong>
  </p>

  <p class="margin-bottom-8 clearfix" *ngIf="price.priceHistory.majorAmount !== 0">
    <span class="pull-right"><span *ngIf="amendType === 'payment'">+ </span><span *ngIf="amendType === 'refund'">-
      </span>{{price.totalPrice.currencySymbol}}{{price.totalPrice.currencySymbol==="CHF" ? ' ' : ''}}{{
      price.priceHistory.majorAmount }}</span>
    <span *ngIf="amendType === 'payment'"><strong>{{ appCopy.panelHeader['extraCharge'+selectedLanguage]
        }}</strong></span>
    <span *ngIf="amendType === 'refund'"><strong>{{ appCopy.panelHeader['refundAmount'+selectedLanguage]
        }}</strong></span>
  </p>

</div>
